import { render, staticRenderFns } from "./ProfileGroupList.vue?vue&type=template&id=5ba11856"
import script from "./ProfileGroupList.vue?vue&type=script&lang=js"
export * from "./ProfileGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports